import { render, staticRenderFns } from "./frasLiquidacionesF.vue?vue&type=template&id=7541134c"
import script from "./frasLiquidacionesF.vue?vue&type=script&lang=js"
export * from "./frasLiquidacionesF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports